import { Divider } from '@ksyos/design-system';
import type { IOrthOV1ProcedureExaminationsProps } from './OrthOV1ProcedureExaminations';
import { CircleCountHeading } from '../../../elements/CircleCountHeading';
import { OrthOV1ProcedureCheckedVisusExaminations } from './OrthOV1ProcedureCheckedVisusExaminations';
import { OrthOV1ProcedureSelectedExtraVisusExaminations } from './OrthOV1ProcedureSelectedExtraVisusExaminations';

export function OrthOV1ProcedureVision(props: IOrthOV1ProcedureExaminationsProps) {
    return (
        <>
            <CircleCountHeading
                count="4"
                label="Visus"
            />
            <OrthOV1ProcedureCheckedVisusExaminations {...props} />
            <OrthOV1ProcedureSelectedExtraVisusExaminations {...props} />
            <Divider
                color="minimal"
                spacing="medium"
            />
        </>
    );
}
